<template lang="pug">
  .admin-managers
    .admin-managers__title
      h1.title Места
    .admin-managers__content(style="min-width: 1200px;")
      .platform(v-for="platfrom in platforms")
        .sector(v-for="sector in sort(platfrom.sectors)")
          .sector_item Сектор: {{ sector.name }}
          .row(v-for="row in sort(sector.rows)" :key="row.id")
            .row_item {{ row.name }}
            .place(v-for="place in sort(row.places)")
              .item {{ place.name }}
            .place_buttom( @click="appendPlace(row)") +


</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "admin-place",
  components: {},
  data() {
    return {
      platforms: [],
    };
  },
  methods: {
    ...mapActions(["getPlatforms"]),
    sort(item) {
      return item.sort((a, b) => parseInt(a.name) - parseFloat(b.name));
    },
    appendPlace(row) {
      let platform_ = this.platforms;
      platform_.forEach((i) => {
        i.sectors.forEach((s) => {
          s.rows.forEach((r) => {
            if (r.id === row.id) {
              row.places.push({
                name: parseInt(row.places[row.places.length - 1].name) + 1,
              });
            }
          });
        });
      });
      this.$set(this.platforms, platform_);
    },
  },
  mounted() {
    this.getPlatforms().then((res) => {
      this.platforms = res;
    });
  },
};
</script>
